/**
 * Mint new ids for custom field definitions copied from the clipboard.
 * Array indexes in the clipboard become the keys of the returned maps.
 */

import { generateId } from '../constants';

/**
 * @param {Array} clipboardCustomFieldDefs - Custom field definitions from clipboard (indexed format)
 * @param {number} timestamp - Timestamp for ID generation
 * @returns {{ definitions: Array, fieldIdMap: Map, optionIdMap: Map }}
 */
export function generateCustomFieldIds(clipboardCustomFieldDefs, timestamp) {
  if (!clipboardCustomFieldDefs || clipboardCustomFieldDefs.length === 0) {
    return { definitions: [], fieldIdMap: new Map(), optionIdMap: new Map() };
  }

  const fieldIdMap = new Map(); // fieldIndex -> newFieldId
  const optionIdMap = new Map(); // "fieldIndex-optionIndex" -> newOptionId

  const definitions = clipboardCustomFieldDefs.map((field, fieldIdx) => {
    const newFieldId = generateId('cf', timestamp, fieldIdx);
    fieldIdMap.set(fieldIdx, newFieldId);

    let options;
    if (field.type === 'select' && field.options) {
      options = field.options.map((opt, optIdx) => {
        const newOptId = generateId('opt', timestamp, fieldIdx, optIdx);
        optionIdMap.set(`${fieldIdx}-${optIdx}`, newOptId);
        return {
          id: newOptId,
          label: opt.label,
          color: opt.color,
        };
      });
    }

    return {
      id: newFieldId,
      name: field.name,
      type: field.type,
      order: fieldIdx,
      options,
    };
  });

  return { definitions, fieldIdMap, optionIdMap };
}
